import React, { Component } from "react";
import { connect } from "react-redux";
import { allMember } from "../../Redux/action/memberAction";
import { CheckLoader } from "../../Redux/action/visitorAction";
import SwKpi from "../Common/SwKPI/SwKPI";
import SwKpiGroup from "../Common/SwKPI/SwKpiGroup";

class MemberInformationPannel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedKpi: "all", // ✅ First KPI selected by default
    };
  }

  componentDidMount() {
    // ✅ Apply default filter
    this.props.getActiveMember("notInactive");
  }

  handleFilter = (key, status) => {
    const { selectedKpi } = this.state;

    if (selectedKpi === key) {
      this.props.getActiveMember("");
      this.setState({ selectedKpi: "" });
    } else {
      this.props.getActiveMember(status);
      this.setState({ selectedKpi: key });
    }
  };

  render() {
    const activeUserList = this.props.activeUserList.userList || {};
    const { selectedKpi } = this.state;

    return (
      <div className="row">
        <div className="col-12">
          <SwKpiGroup>
            <SwKpi
              label="New Requests + Has Access"
              value={(activeUserList.active || 0) + (activeUserList.pending || 0)}
              active={selectedKpi === "all"} // ✅ default active
              tooltip="Apply filter in New Requests + Has Access."
              onClick={() =>
                this.handleFilter("all", "notInactive")
              }
            />

            <SwKpi
              label="Has Access"
              value={activeUserList.active || 0}
              active={selectedKpi === "active"}
              tooltip="Apply filter in Active Members."
              onClick={() =>
                this.handleFilter("active", "active")
              }
            />

            <SwKpi
              label="Active SPOCs"
              value={activeUserList.spoc || 0}
              active={selectedKpi === "spoc"}
              tooltip="Apply filter in Active SPOCs."
              onClick={() =>
                this.handleFilter("spoc", "spoc")
              }
            />

            <SwKpi
              label="No Access"
              value={activeUserList.inactive || 0}
              active={selectedKpi === "inactive"}
              tooltip="Apply filter in Inactive Members."
              onClick={() =>
                this.handleFilter("inactive", "inactive")
              }
            />
          </SwKpiGroup>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activeUserList: state.activeUserList,
});

export default connect(mapStateToProps, {
  allMember,
  CheckLoader,
})(MemberInformationPannel);
